<template>
  <v-row no-gutters>
    <template>
      <div class="p-3">
        <v-card>
          <v-card-title>
            <v-row>
              <v-col md="4" sm="12">
                <v-text-field v-model="search" append-icon="mdi-magnify" label="Cari" single-line
                  hide-details></v-text-field>
              </v-col>
            </v-row>
          </v-card-title>
          <v-data-table :headers="headers" :search="search" :items="internshipData" v-model="selected" item-key="name"
            sort-by="calories" class="elevation-1">
            <template v-slot:top>
              <v-toolbar flat>
                <v-toolbar-title>Verifikasi Surat Balasan</v-toolbar-title>
                <v-divider class="mx-4" inset vertical></v-divider>
                <v-spacer></v-spacer>
              </v-toolbar>
            </template>
            <template v-slot:item.status="{ item }">
              <v-chip class="ma-2" small color="amber accent-1">
                <v-icon left>
                  mdi-timeline-clock
                </v-icon>
                {{ item.status }}
              </v-chip>
            </template>
            <template v-slot:item.actions="{ item }">
              <v-icon color="dark" class="mr-2" @click="onActionVerifyClick(item)">
                mdi-file-check
              </v-icon>
            </template>
            <template v-slot:no-data>
              Belum ada data
            </template>
          </v-data-table>
        </v-card>
      </div>
    </template>
  </v-row>
</template>
<script>
export default {
  data: () => ({
    search: null,
    dialog: false,
    dialogDelete: false,
    selected: [],
    headers: [
      {
        text: 'Nama',
        align: 'start',
        value: 'nama',
      },
      { text: 'NIM', value: 'no_induk' },
      { text: 'Tanggal daftar', value: 'created_at' },
      { text: 'Realisasi mulai KP', value: 'realisasi_mulai_kp' },
      { text: 'Perusahaan', value: 'perusahaan_tujuan' },
      { text: 'Diterima/Ditolak', value: 'hasil' },
      { text: 'Status', value: 'status' },


      { text: 'Actions', value: 'actions', sortable: false },
    ],
    internshipData: [],
  }),

  computed: {
    formTitle() {
      return this.editedIndex === -1 ? 'New Item' : 'Edit Item'
    },
  },

  watch: {
    dialog(val) {
      val || this.close()
    },
  },

  created() {
    this.getData();
    this.initialize()
  },

  methods: {
    getData() {
      this.axios.get("/api/verifikasi/surat-balasan").then((res) => {
        console.log(res.data.data);
        this.internshipData = res.data.data.map(val => {
          val.created_at = new Date(val.tanggal_daftar).toLocaleDateString('id-ID', { month: 'short', year: 'numeric', day: 'numeric' });
          val.realisasi_mulai_kp = val.perusahaan.surat_balasan.kode_jenis_surat == 'SDTR' ? this.$dates.dateNoDayNoTime(val.realisasi_mulai_kp) : '-';
          // val.rencana_mulai_kp = new Date(val.kp.tanggal_rencana_mulai_kp).toLocaleDateString('id-ID', { month: 'short', year: 'numeric', day: 'numeric' });
          val.hasil = val.perusahaan.surat_balasan.kode_jenis_surat == 'SDTR' ? 'Diterima' : "Ditolak";
          val.perusahaan_tujuan = val.perusahaan.nama;
          val.status = 'Menunggu verifikasi surat';
          return val;
        })
      }).finally(() => console.log('didit'));
    },
    initialize() {
    },

    onActionVerifyClick(item) {
      // console.log(item.perusahaan);
      this.$router.push({ name: 'validate-read', query: { read: item.perusahaan.surat_balasan.id, type: item.perusahaan.surat_balasan.kode_jenis_surat } })
    },

    close() {
      this.dialog = false
    },

  },
}
</script>